import { Stack, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import { useAuth } from "@/providers";
import { Comments } from "@/shared/components/comments";
import { useCommentsForUser } from "@/shared/domain/comments/hooks";

interface UserCommentsProps {
  userId: string;
}

export function UserComments({ userId }: UserCommentsProps) {
  const theme = useTheme();
  const { orgRoles, currentUser } = useAuth();

  const [avatarMap, setAvatarMap] = useState<{ [key: string]: string }>({});

  const { data: comments = [], isLoading } = useCommentsForUser({ userId });

  // Build avatar map from org roles
  useEffect(() => {
    if (orgRoles === null) {
      return;
    }

    const newAvatarMap: { [key: string]: string } = {};
    orgRoles.forEach((role) => {
      newAvatarMap[role.user.user_id] = role.user.picture_url ?? "";
    });

    setAvatarMap(newAvatarMap);
  }, [orgRoles]);

  // Show only the first 5 comments
  const displayedComments = comments.slice(0, 5);

  if (isLoading) {
    return null; // Or a skeleton loader
  }

  return (
    <Stack
      sx={{
        mt: theme.spacing(1),
        width: "60%",
      }}
    >
      <Typography variant="body1">Recent Comments</Typography>
      <Stack sx={{ mt: theme.spacing(2) }}>
        <Comments.List>
          {displayedComments.map((comment) => {
            const avatarUrl = avatarMap[comment.created_by] ?? "";
            return (
              <Comments.Item
                key={comment.comment_id}
                comment={comment}
                avatarUrl={avatarUrl}
                currentUserId={currentUser?.user_id ?? ""}
                summaryView={true}
              />
            );
          })}
        </Comments.List>
      </Stack>
    </Stack>
  );
}
